import React from "react";
import { CustomLink } from "../custom-link";
import { awaitHelper, accessCheck } from "../../utils";
import get from "lodash/get";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AccessType } from "@quintype/components";
import LogedinUser from "../../../assets/icons/logedin-user-icon.svg";
import { SvgHandler } from "../svg-handler/svg-handler";
import "./user-profile.m.css";

class UserDataBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserData: false,
      loadingSubscriptionPlans: false
    };
    this.toggleUserData = this.toggleUserData.bind(this);
  }

  componentDidUpdate() {
    if (
      this.props.memberSubscriptions &&
      this.props.memberSubscriptions.length === 0 &&
      !this.state.loadingSubscriptionPlans
    ) {
      this.getUserSubscriptions();
    }
  }

  getUserSubscriptions = async () => {
    this.setState({ loadingSubscriptionPlans: true });
    const { subscriptions } = await this.props.getSubscriptionForUser();
    this.props.updateMemberSubscriptions(subscriptions);
    this.setState({ subscriptions });
  };

  toggleUserData = () => {
    this.setState({ showUserData: !this.state.showUserData });
  };

  async logoutHandler(event, logout) {
    event.persist();
    event.preventDefault();
    event.stopPropagation();
    const { error, data } = await awaitHelper(logout());
    this.toggleUserData();
    if (error) {
      console.warn(`Logout failed`);
    }
    return data;
  }

  fallbackImage() {
    const image = get(this.props, ["member", "avatar-url"]);
    if (image) {
      return <img styleName="avatar" src={image} />;
    }
    return (
      <span>
        <SvgHandler xlinkHref={LogedinUser} clazzName="author-icon" width="24" height="24" viewBox="0 0 24 24" />
      </span>
    );
  }

  render() {
    return (
      <>
        <div
          data-testid="user-details"
          onClick={this.toggleUserData}
          styleName={`user-details ${this.props.customCssClasses}`}
        >
          {this.fallbackImage()}
          {this.state.showUserData && (
            <div styleName="overlay">
              <div styleName="user-data">
                <ul>
                  <li>
                    <CustomLink href={"/user-details"} callback={this.toggleUserData}>
                      My profile
                    </CustomLink>
                  </li>
                  <li>
                    <div>
                      <a href={"#"} onClick={event => this.logoutHandler(event, this.props.logout)}>
                        Logout
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}
function UserDataTemplate(props) {
  const email = get(props, ["member", "email"]);
  const phone = get(props, ["member", "metadata", "phone-number"], "1234");
  const accessTypeKey = get(props, ["config", "theme-attributes", "accesstypeKey"]);
  const isStaging = get(props, ["config", "theme-attributes", "accesstypeEnvironment"]) === "staging";
  const enableAccesstype = get(props, ["config", "theme-attributes", "enableAccesstype"], false);

  return (
    <AccessType
      enableAccesstype={accessCheck(enableAccesstype)}
      isStaging={isStaging}
      accessTypeKey={accessTypeKey} // "9rm1ijqQmGfJ2kwQ9zt2gWhK"
      email={email}
      phone={phone}
    >
      {({ getSubscriptionForUser }) => <UserDataBase getSubscriptionForUser={getSubscriptionForUser} {...props} />}
    </AccessType>
  );
}

UserDataBase.propTypes = {
  member: PropTypes.object,
  logout: PropTypes.func,
  subscriptions: PropTypes.array,
  getSubscriptionForUser: PropTypes.func,
  updateMemberSubscriptions: PropTypes.func,
  memberSubscriptions: PropTypes.array,
  customCssClasses: PropTypes.string
};

const mapStateToProps = state => {
  return {
    config: get(state, ["qt", "config"]),
    member: get(state, ["member"], null),
    subscriptions: get(state, ["subscriptions"], []),
    memberSubscriptions: get(state, ["memberSubscriptions"], [])
  };
};

const mapDispatchToProps = dispatch => ({
  updateMemberSubscriptions: subscriptions => dispatch({ type: "MEMBER_SUBSCRIPTIONS_UPDATED", subscriptions })
});

export const UserData = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDataTemplate);
